/**
 * `/auth/error` — shown when the post-login refresh fails. Offers a manual route
 * back to the centralized login.
 */
import { useTranslation } from 'react-i18next';
import { SkipLink } from '@/components/SkipLink';
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';
import { HOME_PATH } from '@/routes/home';

export function AuthError() {
  const { t } = useTranslation();
  return (
    <>
      <SkipLink />
      <main
        id="main"
        tabIndex={-1}
        style={{ padding: '2rem', maxWidth: '32rem', margin: '0 auto' }}
      >
        <h1>{t('auth.errorTitle')}</h1>
        <p>{t('auth.errorBody')}</p>
        <button type="button" onClick={() => redirectToCentralizedLogin(HOME_PATH)}>
          {t('auth.tryAgain')}
        </button>
      </main>
    </>
  );
}
